export default {
  zIndex: 1000,
  getZIndex() {
    this.zIndex += 1
    return this.zIndex
  }
}
